/**
 * Login
 */
export const SET_LOGIN_USER = "SET_LOGIN_USER";
export const SET_LOGIN_FLAG = "SET_LOGIN_FLAG";
export const SET_PERMISSONS = "SET_PERMISSONS";
export const SET_SUB_ADMIN_PERMISSONS="SET_SUB_ADMIN_PERMISSONS"
export const SET_SUB_ADMIN_TYPE="SET_SUB_ADMIN_TYPE"


export const SET_SIDEBAR_STATUS = "SET_SIDEBAR_STATUS";
export const SET_GYM_DATA = "SET_GYM_DATA";
export const SET_GYM_ATTRIBUTE = "SET_GYM_ATTRIBUTE";
export const SET_TRAINER_DATA = "SET_TRAINER_DATA";
export const SET_TRAINER_ATTRIBUTE = "SET_TRAINER_ATTRIBUTE";
export const SET_TRAINERS_DATA = "SET_TRAINERS_DATA";
export const SET_TRAINER_COUNT = "SET_TRAINER_COUNT";
export const SET_PLAN_DATA = "SET_PLAN_DATA";
export const ADD_GYM_MODAL = "ADD_GYM_MODAL";
export const SET_CHECKIN_POP_OPEN = "SET_CHECKIN_POP_OPEN";
export const SET_EXPIRING_TODAY_POP_OPEN = "SET_EXPIRING_TODAY_POP_OPEN";
export const SET_EXPIRING_TODAY_DATA = "SET_EXPIRING_TODAY_DATA";
export const ADD_APPOINTMENT_MODALL = "ADD_APPOINTMENT_MODALL";
export const ADD_TRAINER_MODAL = "ADD_TRAINER_MODAL";
export const ADD_PACKAGE_MODAL = "ADD_PACKAGE_MODAL";
export const ADD_USER_MODAL = "ADD_USER_MODAL";
export const SET_RETAIL_MODAL="SET_RETAIL_MODAL"
export const ADD_PRIVATE_MODAL = "ADD_PRIVATE_MODAL";
export const ADD_WOD_MODAL = "ADD_WOD_MODAL";
export const ADD_CLASS_MODAL = "ADD_CLASS_MODAL";
export const ADD_SALE_MODAL = "ADD_SALE_MODAL";
export const ADD_STAFF_MODAL = "ADD_STAFF_MODAL";
export const SET_SCANNER_CHECKIN_TOKEN = "SET_SCANNER_CHECKIN_TOKEN";

export const SET_MEMBER_DATA = "SET_MEMBER_DATA";
export const SET_MEMBERS_DATA = "SET_MEMBERS_DATA";
export const SET_MEMBER_COUNT = "SET_MEMBER_COUNT";
export const ADD_MEMBER_MODAL = "ADD_MEMBER_MODAL";
export const SET_MESSAGE_DATA = "SET_MESSAGE_DATA";
export const SET_MEMBERS_CHECKIN_DATA = "SET_MEMBERS_CHECKIN_DATA";
export const SET_PACKAGE = "SET_PACKAGE";

export const SET_REPORTS_DATA = "SET_REPORTS_DATA";
export const SET_REPORTS_COUNT = "SET_REPORTS_COUNT";
export const SET_REPORTS_SUMMARY = "SET_REPORTS_SUMMARY";

export const SET_INVOICE_DATA = "SET_INVOICE_DATA";
export const SET_INVOICE_COUNT = "SET_INVOICE_COUNT";
export const SET_INVOICE_SUMMARY = "SET_INVOICE_SUMMARY";

export const SET_WOD_DATA = "SET_WOD_DATA";
export const SET_WODS_DATA = "SET_WODS_DATA";
export const SET_WOD_COUNT = "SET_WOD_COUNT";

export const SET_STAFF_DATA = "SET_STAFF_DATA";
export const SET_STAFF_COUNT = "SET_STAFF_COUNT";

// export const SET_MESSAGE_DATA = 'SET_MESSAGE_DATA';

export const SET_PACKAGE_COUNT = "SET_PACKAGE_COUNT";
export const SET_PACKAGES_DATA = "SET_PACKAGES_DATA";

export const SET_CLASS_COUNT = "SET_CLASS_COUNT";
export const SET_CLASSES_DATA = "SET_CLASSES_DATA";
export const SET_CLASS_DATA = "SET_CLASS_DATA";

export const SET_NOTIFICATIONS_DATA = "SET_NOTIFICATIONS_DATA";
export const SET_UNREAD_NOTIFICATION_COUNT = "SET_UNREAD_NOTIFICATION_COUNT";
export const SET_PAGE_LIMIT = "SET_PAGE_LIMIT";
export const ALERT_MODAL = "ALERT_MODAL";
export const SET_SUBSCRIBEDMEMBERS_DATA = "SET_SUBSCRIBEDMEMBERS_DATA";
export const SET_SUBSCRIBEDMEMBERS_COUNT = "SET_SUBSCRIBEDMEMBERS_COUNT";

export const SET_TRAINER_DASHBOARD_CARD_DATA =
  "SET_TRAINER_DASHBOARD_CARD_DATA";

export const SET_TRAINER_DASHBOARD_LIVE_DATA =
  "SET_TRAINER_DASHBOARD_LIVE_DATA";

export const SET_GYM_DASHBOARD_CARD_DATA = "SET_GYM_DASHBOARD_CARD_DATA";

export const SET_GYM_DASHBOARD_LIVE_DATA = "SET_GYM_DASHBOARD_LIVE_DATA";
export const SET_BOOKINGS = "SET_BOOKINGS";
export const SET_SALES = "SET_SALES";
export const SET_EXPANSION_COUNT = "SET_EXPANSION_COUNT";
export const SET_EXPANSION_SUMMARY = "SET_EXPANSION_SUMMARY";
export const TOGGLE_INFO_CLASS_MODAL_OPEN = "TOGGLE_INFO_CLASS_MODAL_OPEN";
export const TOGGLE_EDIT_CLASS_MODAL = "TOGGLE_EDIT_CLASS_MODAL";
export const TOGGLE_CLASS_CANCEL_MODAL = "TOGGLE_CLASS_CANCEL_MODAL";
export const TOGGLE_BOOKING_CANCEL_MODAL = "TOGGLE_BOOKING_CANCEL_MODAL";
export const COLLAPSE_SIDE_BAR = "COLLAPSE_SIDE_BAR";
export const SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE = "SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE";
export const SET_TRAINER_CALENDAR_SCHEDULE = "SET_TRAINER_CALENDAR_SCHEDULE";
export const SET_ADD_PROGRAM_MODAL_OPEN = "SET_ADD_PROGRAM_MODAL_OPEN";


export const SET_GYM_FEATURES_DATA = "SET_GYM_FEATURES_DATA";
export const SET_GYM_FEATURES_OBJECT = "SET_GYM_FEATURES_OBJECT";

export const SET_PAYEMNT_GATEWAYS_BY_REGION = "SET_PAYEMNT_GATEWAYS_BY_REGION";
export const SET_PAYMENT_GATEWAYS_FIELDS = "SET_PAYMENT_GATEWAYS_FIELDS";
export const SET_PAYMENT_GATEWAY_FIELDS_VALUE = "SET_PAYMENT_GATEWAY_FIELDS_VALUE";
export const SET__SAVE_PAYMENT_GATEWAY_FIELDS_VALUE = "SET__SAVE_PAYMENT_GATEWAY_FIELDS_VALUE";
export const SET_PAYMENT_GATEWAY_FIELDS_ERROR = "SET_PAYMENT_GATEWAY_FIELDS_ERROR";
export const SET_PAYMENT_GATEWAY_FIELDS_SUCCESS = "SET_PAYMENT_GATEWAY_FIELDS_SUCCESS";
export const SET_PAYMENT_GATEWAYS_USED = "SET_PAYMENT_GATEWAYS_USED";
export const SET_MEMBER_AT_RISK = "SET_MEMBER_AT_RISK";
export const SET_STATS = "SET_STATS";

export const SET_PAY_RATES_TYPE = "SET_PAY_RATES_TYPE";
export const SET_PAY_RATES_DATA = "SET_PAY_RATES_DATA";
export const SET_PAY_RATE = "SET_PAY_RATE";
export const SET_PAY_RATES_STAFF_DATA = "SET_PAY_RATES__STAFF_DATA";